<template>
    <div>
         <div class="header-wrapper">
        </div>
        <div class="dashboard-content">
            <b-container>
                <b-row class="mt-3 justify-content-md-center">
                    <b-col lg="10" md="12" sm="12" class="c-box schedule-box p-0">
                        <div class="heading">Camp Schedule</div>
                         <div class="table-box">
                            <div class="session-box mt-4" v-for="(item, i) in schedule" :key="i">
                                <div class="header"><span class="fe-calendar"></span>   {{dates[i]}}</div>
                                <b-row>
                                    <b-col sm="12" md="12" lg="6">
                                        <table>
                                            <tr class="schedule-item" v-for="(unit, j) in item[0]" :key="j">
                                                <td width="20%">
                                                    <div class="time">8:30 AM</div>
                                                </td>
                                                <td>
                                                    <div class="message">
                                                        <div class="title">{{unit.heading}}</div>
                                                        <div class="subtitle">{{unit.speaker}}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <router-link :to="{name: 'dashboard-view'}">
                                                        <div class="play-btn"><span class="fe-play"></span></div>
                                                    </router-link>
                                                </td>
                                            </tr>
                                        </table>
                                    </b-col>
                                    <b-col sm="12" md="12" lg="6">
                                        <table>
                                            <tr class="schedule-item" v-for="(unit, j) in item[1]" :key="j">
                                                <td width="20%">
                                                    <div class="time">8:30 AM</div>
                                                </td>
                                                <td>
                                                    <div class="message">
                                                        <div class="title">Walking in the Spirit</div>
                                                        <div class="subtitle">Pastor Elikem</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="play-btn"><span class="fe-play"></span></div>
                                                </td>
                                            </tr>
                                        </table>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import Moment from 'moment'

    export default {
        components: {
            vueCustomScrollbar
        },
        data(){
            return {
                result: [],
                schedule: [],
                dates: []
            }
        },
        methods: {
             getSchedule(){
                this.$http.get('get-schedule')
                .then(res => {
                    let result = res.body.schedule
                    let newResult = [];
                    let dates = [];

                    for (let i = 0; i < result.length; i++) {
                        if(result[i].scheduleDate !== undefined){
                            let index;
                            if(!dates.includes(result[i].scheduleDate)){
                                dates.push(result[i].scheduleDate)
                                index = dates.indexOf(result[i].scheduleDate)

                                newResult[index] = []
                                newResult[index][0] = []
                                newResult[index][1] = []

                                if(i % 2 === 1){
                                    newResult[index][0].push(result[i])
                                }

                                if(i % 2 === 0){
                                    newResult[index][1].push(result[i])
                                }
                            }else{
                                index = dates.indexOf(result[i].scheduleDate);

                                if(i % 2 === 1){
                                    newResult[index][0].push(result[i])
                                }

                                if(i % 2 === 0){
                                    newResult[index][1].push(result[i])
                                }
                            }
                        }
                    }
                    this.dates = dates.map(item => {
                        return Moment(item).format('Do MMMM YYYY')
                    })
                    this.schedule = newResult
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        created(){
            this.getSchedule()
        }
    }
</script>

<style lang="scss" scoped>
    .header-wrapper{
        padding: 20px;
        text-align: center;
        font-size: 20px;
        color: #182c8f; 
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
        h1{
            margin-bottom: 0;        
        }
    }
    .schedule-box{
        margin: 0 auto;
        margin-top: 40px;
        width: 100%;
        .session-box{
            font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
            margin-bottom: 10px;
            .header{
                padding: 10px 20px;
                background-color: rgb(241, 241, 241);
                color: rgb(35, 35, 83)
            }
            table{
                width: 100%;
                display: inline-block;
            }
            .schedule-item{
                td{
                    border-bottom: 1px solid rgba(192, 192, 192, 0.212);
                    .time{
                        padding: 10px;
                        vertical-align: middle;
                        color: rgb(35, 35, 83);
                        font-weight: bold;
                        font-size: 16px;
                    }
                    .message{
                        padding: 10px;
                        .title{
                            color: rgb(35, 35, 83);
                            font-weight: bold;
                        }
                        .subtitle{
                            color: silver;
                            font-size: 16px;
                        }
                    }
                    .play-btn{
                        background-color: red;
                        width: 30px;
                        padding: 5px 10px;
                        color: white;
                        border-radius: 25px;
                        cursor: pointer;
                        text-align: center;
                        margin: 0 auto;
                    }
                }
            }
        }
    }
</style>